// @charset "utf-8"
/* eslint-disable no-undef */
/* eslint-disable no-new */
import cookieApi from '@/lib/cookieApi'
const state = {
    userName: cookieApi.get('escapename'),
    userId: cookieApi.get('userid'),
    phone: '',
    avatar: cookieApi.get('userid') ? `//u.thsi.cn/avatar/${cookieApi.get('userid').toString().slice(-4)}/${cookieApi.get('userid')}` : ''
}
const mutations = {
    update (state, data) {
        state.userName = data.name
        state.userId = data.user_id
        state.phone = data.phone
        state.avatar = data.avatar
    }
}
const actions = {

}

const getters = {
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js